import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Mouth_3 = ({ skinColours, lipColours }) => {
  const colour0 = skinColours.shadow;
  const colour1 = lipColours.shadow;
  const colour2 = lipColours.base;
  const colour3 = lipColours.shadow;
  const colour4 = lipColours.shadow;
  const colour5 = '#40332E';

  return (
    <>
      <g>
        <path
          fill={colour0}
          d="M376.8,572.5l0.4,1.6c0,0,16.5-5,36.7,1.3l2-0.4c0,0-12.5-5.2-19.1-6.5L376.8,572.5z"
        />
        <path
          fill={colour0}
          d="M382.7,519.9c0,0,7.2-3.6,9.8-3.6c2.7,0,14.3,8.9,26.9,2.8c0,0-0.2,2.9-5.4,3c-5.1,0.1-12.5,2.4-12.5,2.4
		S386.3,525.1,382.7,519.9z"
        />
        <path
          fill={colour1}
          d="M395.5,551.8c-20.4-1.2-57.8,11.4-57.8,11.4c14.3-2.5,37.5-2.8,58-2.4c17.8,0.3,37,1.5,51.2,1.7L395.5,551.8z"
        />
        <path
          fill={colour2}
          d="M319.8,570.1c-5,2.4-1.2,17.3-1.8,18.6c-0.7,1.6-8.7,7.9-8.7,7.9s-4.8-10-5.2-11.5c-0.5-1.6,11.4-14.3,12.8-16
		c1.3-1.6,44-36.7,83.4-36.7c15.3,0,64.6,28.2,78.8,41.5c2.4,2.3,14,6.9,14,6.9L490,593c0,0-11.9-5.4-13.8-7.2
		c-0.8-0.8,1.6-10.4-5.9-16.7c-3-2.5-47-10.3-73.2-11.3C351.8,556.1,319.8,570.1,319.8,570.1z"
        />
        <path
          fill={colour3}
          d="M318.3,571.2c0.2,4.4,0.1,13.5-0.5,14.7c-0.7,1.5-7.2,4.6-7.2,4.6s-2.6-4.7-3-6.1c-0.5-1.5,6.4-12.7,7.8-14.2
		c1.3-1.5,44.9-29.1,84.3-28.9c13,0.1,66.3,18.5,79.5,32.5c2.2,2.3,8.7,6.1,8.7,6.1l0.1,8.1c0,0-9.9-2.8-11.8-4.5
		c-0.8-0.7-0.5-9.9-3.2-12.6s-46.3-27.1-72.5-28.3C357.7,540.7,318.3,571.2,318.3,571.2z"
        />
        <path
          fill={colour4}
          d="M416.1,555c-5.3-0.5-26.5-6.1-21.9-8.6c4.6-2.5,24.3,1.5,25.6,2.8C421.2,550.6,419.6,555.3,416.1,555z"
        />
        <path
          fill={colour5}
          d="M476.1,574.1c0,0,1,7.8,3.6,8.5s4.4-1.7,3.2-2.9C481.7,578.5,476.1,574.1,476.1,574.1z"
        />
        <path
          fill={colour4}
          d="M390.2,546.3c-1.5,1.8-7.6,5.3-10.1,4.1c-2.5-1.2,0.2-4.2,2.3-4.8C384.4,545.1,391.6,544.6,390.2,546.3z"
        />
        <path
          fill={colour5}
          d="M317,574.4c-0.7,3.6-0.2,10.9-3.6,11.2c-1.3,0.1-2.3-1.8-1.5-3.9C313.2,578.4,317,574.4,317,574.4z"
        />
      </g>
    </>
  );
};

export default Mouth_3;
